export default "__VITE_ASSET__CxE3Kl9___"